import { gsap } from 'gsap';
import * as PIXI from 'pixi.js';
import GlobalDispatcher from '../events/GlobalDispatcher';
import eWSEventId from '../api/eWSEventId';
import eEventType from '../events/eEventType';
import ControllerGround from './elements/ControllerGround';
import ControllerSky from './elements/ControllerSky';
import ControllerBGObjects from './elements/ConotrollerBGObjects';
import ControllerFlags from './elements/ControllerFlags';
import ControllerCratesContainer from './elements/ControllerCratesContainer';
import ManagerResult from '../ManagerResult';
import eGameState from '../models/eGameState';
import GameModel from '../models/GameModel';
import ControllerBushes from './elements/ControllerBushes';

export default class ControllerBG {
  constructor(mainContainer) {
    this.mainContainer = mainContainer;

    this.controllerSky = new ControllerSky(mainContainer);
    this.conrollerBGObjects = new ControllerBGObjects(mainContainer);
    this.controllerGround = new ControllerGround(mainContainer);
    this.controllerCratesContainer = new ControllerCratesContainer(mainContainer);
    this.controllerrBushes = new ControllerBushes(mainContainer);
    this.controllerFlags = new ControllerFlags(mainContainer, this.conrollerBGObjects.container);

    this._buildBlocker();

    GlobalDispatcher.add(eWSEventId.EWEI_START, this.startAnimation, this);
    GlobalDispatcher.add(eWSEventId.EWEI_PROGRESS, this.syncAnimation, this);
    GlobalDispatcher.add(eWSEventId.EWEI_FINISH, this._onFinish, this);

    ManagerResult.controllerBG = this;

    if (GameModel.state === eGameState.EGS_PROGRESS) {
      this.setX(GameModel.currentX);
    }
  }

  async _onFinish() {
    this.stopAnimation();
  }

  startAnimation() {
    gsap.killTweensOf(this.blocker);
    this.blocker.alpha = 0;
  }

  setX(value) {
    this.controllerSky.setX(value);
    this.controllerGround.setX(value);
    this.controllerrBushes.setX(value);
    this.conrollerBGObjects.setX(value);
    this.controllerCratesContainer.setX(value);
    this.controllerFlags.reset();
  }

  syncAnimation(data) {
    this.controllerSky.syncAnimation(data);
    this.controllerGround.syncAnimation(data);
    this.controllerrBushes.syncAnimation(data);
    this.conrollerBGObjects.syncAnimation(data);
    this.controllerCratesContainer.syncAnimation(data);
  }

  stopAnimation() {
    this.controllerSky.stopAnimation();
    this.controllerGround.stopAnimation();
    this.controllerrBushes.stopAnimation();
    this.conrollerBGObjects.stopAnimation();
    this.controllerCratesContainer.stopAnimation();
  }

  resetPositions() {
    this.controllerSky.reset();
    this.controllerFlags.reset();
    this.controllerGround.reset();
    this.controllerrBushes.reset();
    this.conrollerBGObjects.reset();
    this.controllerCratesContainer.reset();
    GlobalDispatcher.dispatch(eEventType.EET_RESET);
  }

  _buildBlocker() {
    if (this.blocker)
      this.blocker.destroy();

    this.blocker = new PIXI.Graphics();
    this.blocker.beginFill('0x000000');
    this.blocker.drawRect(0, 0, 1015, 650);
    this.blocker.alpha = 0;
    this.mainContainer.addChildAt(this.blocker, this.mainContainer.children.length);
  }

  animateBlocker(alpha) {
    return new Promise(((resolve) => gsap.to(this.blocker, { duration: 0.5, alpha: alpha, onComplete: resolve })))
  }
}
